import { render, staticRenderFns } from "./layoutHeader.vue?vue&type=template&id=8df858a6&scoped=true"
import script from "./layoutHeader.vue?vue&type=script&lang=js"
export * from "./layoutHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df858a6",
  null
  
)

export default component.exports